/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Rehearse_This_Meeting_TitleInputs */



/**
* | output |
* | --- |
* | "Practise this conversation" |
*
* @param {Nudge_Rehearse_This_Meeting_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_rehearse_this_meeting_title = /** @type {((inputs?: Nudge_Rehearse_This_Meeting_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Rehearse_This_Meeting_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dit gesprek oefenen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Répéter cette conversation")
	return /** @type {LocalizedString} */ ("Practise this conversation")
});